import {Button, Paper, Step, StepContent, StepLabel, Stepper} from '@material-ui/core';
import 'Core/components/TermsAndConditions/LegalAcceptance.sass';
import {acceptAgreements, getLegalAgreementsText} from 'Core/ducks/legalAcceptance';
import {isLoaded, toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {renderAsync} from 'Shared/components/RenderAsync';
import {prop} from 'Shared/utilities/prop';
import {logoutISAM} from "../../ducks/refreshToken";
import parse from 'html-react-parser';

const LegalAcceptance = () => {
    const dispatch = useDispatch();
    const {userClaims} = useSelector((state: ReducerState) => state.user.profile);
    const {legalAgreementTexts} = useSelector((state: ReducerState) => state.legalAcceptance);
    const [agreementStep, setAgreementStep] = useState(0);

    useEffect(() => {
        if (isLoaded(userClaims)) {
            dispatch(getLegalAgreementsText(userClaims.Data.unacceptedLegalDocuments.map(prop('id'))));
        }
    }, []);

    useEffect(() => {
        if (isLoaded(userClaims) && agreementStep === userClaims.Data.unacceptedLegalDocuments.length) {
                    dispatch(acceptAgreements(userClaims.Data.id, userClaims.Data.unacceptedLegalDocuments.map(prop('id'))));
                }
    }, [agreementStep]);

    if (isLoaded(userClaims)) {
        return pipe(
            legalAgreementTexts,
            toEither,
            E.fold(renderAsync, agreementsDictionary => (
                <Paper className="legal-acceptance">
                    <p>Please accept the following agreements to continue:</p>
                    <Stepper className="legal-acceptance__agreements" orientation="vertical" activeStep={agreementStep}>
                        {userClaims.Data.unacceptedLegalDocuments.map(legalDocument => (
                            <Step key={legalDocument.id}>
                                <StepLabel>{legalDocument.legalDocumentType.name}</StepLabel>
                                <StepContent>
                                    <div className="legal-acceptance__agreement-text">
                                        {parse(agreementsDictionary[legalDocument.id] || '')}
                                    </div>
                                    <div className="legal-acceptance__agreement-buttons">
                                        <Button
                                            className="legal-acceptance__agree-button"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => setAgreementStep(agreementStep + 1)}
                                        >
                                            I Accept
                                        </Button>
                                        <Button
                                            className="legal-acceptance__disagree-button"
                                            variant="contained"
                                            onClick={() => {
                                                dispatch(logoutISAM())
                                            }}
                                        >
                                            Decline
                                        </Button>
                                    </div>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                    <p className="legal-acceptance__description">
                        By clicking "I Accept" above, I represent and warrant that I have read, understand and agree to
                        abide by
                        American Heritage Life Electronic Service Agreement and Producer HIPAA Business Associate Addendum.
                        I understand
                        that my access and any information viewed and used will be for purposes permitted under federal
                        and state
                        laws and regulations. I agree to only access and use the minimum necessary information required
                        to complete
                        the task for which I am accessing the information.
                    </p>
                </Paper>
            ))
        );
    } else {
        return <></>;
    }
};

export default LegalAcceptance;